import axios from "axios";

/**
 * In dev, `setupProxy.js` maps `/flipkart-sandbox` → https://sandbox-api.flipkart.net (CORS).
 * In production, set this to your backend base URL that forwards to Flipkart with the server-side token.
 */
function baseUrl() {
  if (process.env.NODE_ENV === "development") {
    return "/flipkart-sandbox";
  }
  const b = process.env.REACT_APP_FLIPKART_API_BASE_URL;
  if (b && String(b).trim()) return String(b).replace(/\/$/, "");
  return "";
}

function authHeaders(accessToken) {
  return {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
    Accept: "application/json",
  };
}

/**
 * POST /sellers/orders/sandbox/test_orders
 * @see https://flipkart.github.io/fk-api-platform-docs/docs/mp-api_versioned/create-test-orders
 */
export async function createFlipkartTestOrder(accessToken, body) {
  const base = baseUrl();
  if (!base) {
    throw new Error(
      "Flipkart API base URL is not configured. Set REACT_APP_FLIPKART_API_BASE_URL to your backend proxy, or run the app in development with setupProxy."
    );
  }
  const { data } = await axios.post(`${base}/sellers/orders/sandbox/test_orders`, body, {
    headers: authHeaders(accessToken),
  });
  return data;
}

/**
 * GET /sellers/v3/shipments?orderIds=...
 * @see https://flipkart.github.io/fk-api-platform-docs/docs/mp-api_versioned/get-shipment-details-by-internal-id
 */
export async function getShipmentsByOrderIds(accessToken, orderIdsCsv) {
  const base = baseUrl();
  if (!base) {
    throw new Error(
      "Flipkart API base URL is not configured. Set REACT_APP_FLIPKART_API_BASE_URL to your backend proxy, or run the app in development with setupProxy."
    );
  }
  const { data } = await axios.get(`${base}/sellers/v3/shipments`, {
    params: { orderIds: orderIdsCsv },
    headers: authHeaders(accessToken),
  });
  return data;
}
